import { render, staticRenderFns } from "./SpeceficClientReport.vue?vue&type=template&id=24359dc2&scoped=true&"
import script from "./SpeceficClientReport.vue?vue&type=script&lang=js&"
export * from "./SpeceficClientReport.vue?vue&type=script&lang=js&"
import style0 from "./SpeceficClientReport.vue?vue&type=style&index=0&id=24359dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24359dc2",
  null
  
)

component.options.__file = "SpeceficClientReport.vue"
export default component.exports